import {
  Modal,
  ModalBody,
  ModalContent,
  Text,
  Image,
  Box,
  Flex,
} from "@chakra-ui/react";
import BackIcon from "@/assets/back.png";
import { TokenInfo, useUserInfo } from "@/context/UserInfo";
import {
  formatAmount,
  formatAndToSignificantDigits,
  formatSignificantDigits,
} from "@/utils/formatBalance";
import { useMemo } from "react";
import { ethAddress, usdcInfo } from "@/constants/tokens";
import TitleHeader from "@/components/TitleHeader";
import { useCurrencyExchange } from "@/hooks/useCurrencyExchange";
const SelectAsset = ({
  balanceDue,
  selectedToken,
  onSelectToken,
  isOpen,
  onClose,
}: {
  balanceDue: string;
  selectedToken: TokenInfo | null;
  onSelectToken: (token: TokenInfo) => void;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { tokenInfo } = useUserInfo();
  const { usdToCurrency, currencyUnit } = useCurrencyExchange();

  const balanceList = useMemo(() => {
    const list = Object.values(tokenInfo)
      .filter((token) => token.balance !== "0" || token.address === ethAddress)
      .map((token) => ({
        ...token,
      }));
    // 将ETH放在第一位
    list.sort((a, b) => {
      if (a.symbol === "ETH") return -1;
      if (b.symbol === "ETH") return 1;
      return 0;
    });
    return list;
  }, [tokenInfo]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={"full"}>
      <ModalContent>
        <ModalBody
          sx={{
            background: "#D5742C",
            padding: "20px",
          }}
        >
          <TitleHeader title="Select Asset" onBack={onClose} showSwitch />
          <Flex
            justify={"space-between"}
            align={"flex-end"}
            sx={{ marginTop: "24px", textAlign: "center" }}
          >
            <span
              style={{
                color: "#FFD096",
                fontSize: "16px",
                fontWeight: 900,
                display: "inline-block",
                marginRight: "10%",
                fontFamily: "DIN-BLACK",
              }}
            >
              Balance Due:
            </span>
            <Text>
              <span
                style={{
                  color: "#FFF",
                  display: "inline-block",
                }}
              >
                <span
                  style={{
                    fontFamily: "DIN-BLACK",
                    fontWeight: 900,
                    fontSize: "30px",
                  }}
                >
                  {" "}
                  {formatAmount(
                    usdToCurrency(balanceDue),
                    usdcInfo.decimals
                  )}{" "}
                </span>{" "}
                <span style={{ fontSize: "16px", fontWeight: 700 }}>
                  {currencyUnit}
                </span>
              </span>
            </Text>
          </Flex>

          <Box mt={4}>
            {balanceList.map((token, index) => {
              const isSelected = selectedToken?.address === token.address;
              return (
                <Flex
                  onClick={() => onSelectToken(token)}
                  key={index}
                  sx={{
                    padding: "12px",
                    height: "67px",
                    borderRadius: "32px",
                    marginBottom: "12px",
                    alignItems: "center",
                    background: isSelected ? "#FFD096" : "#fff",
                  }}
                >
                  <Image
                    sx={{
                      width: "36px",
                      height: "36px",
                      marginRight: "12px",
                    }}
                    src={token.icon}
                  ></Image>
                  <Text
                    sx={{
                      color: "#848484",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    {token.symbol}
                  </Text>
                  {token.recommended && (
                    <Flex
                      align={"center"}
                      justify={"center"}
                      sx={{
                        width: "37px",
                        height: "20px",
                        background: isSelected ? "#fff" : "#FFD096",
                        borderRadius: "4px",
                        marginLeft: "12px",
                        color: "#D8762B",
                        textAlign: "center",
                        fontSize: "12px",
                      }}
                    >
                      REC.
                    </Flex>
                  )}
                  <Box
                    sx={{
                      marginLeft: "auto",
                      textAlign: "right",
                      color: "#333",
                    }}
                  >
                    <Text
                      sx={{
                        fontSize: "14px",
                        fontWeight: 700,
                      }}
                    >
                      {formatSignificantDigits(
                        formatAmount(token.balance, token.decimals)
                      )}{" "}
                      {token.symbol}
                    </Text>
                    <Text
                      sx={{
                        fontSize: "12px",
                        fontWeight: 400,
                      }}
                    >
                      {formatAndToSignificantDigits(
                        usdToCurrency(token.value),
                        usdcInfo.decimals
                      )}{" "}
                      {currencyUnit}
                    </Text>
                  </Box>
                </Flex>
              );
            })}
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SelectAsset;
